import React from 'react'
import { Link } from 'react-router-dom'
import { useMatch } from '../context/MatchContext'


export default function Home() {
    const { state, resetMatch } = useMatch()
    const hasOngoing = !!state.match


    return (
        <div className="space-y-6">
            <section className="bg-dark-800 p-5 rounded-2xl shadow-lg border border-dark-700">
                <h2 className="text-xl font-bold text-accent">🏏 Gully Scoreboard</h2>
                <p className="mt-2 text-sm text-gray-300">
                    Create and manage gully cricket matches — fast, simple, mobile-friendly.
                </p>

                <div className="mt-5 grid grid-cols-2 gap-3">
                    <Link
                        to="/new"
                        className="text-center py-2.5 rounded-lg bg-accent text-gray-900 font-semibold hover:bg-emerald-500 transition"
                    >
                        New Match
                    </Link>

                    {hasOngoing && (
                        <Link
                            to="/live"
                            className="text-center py-2.5 rounded-lg bg-dark-700 text-gray-200 hover:bg-dark-600 transition"
                        >
                            Continue
                        </Link>
                    )}
                </div>
            </section>

            {hasOngoing && (
                <section className="bg-dark-800 p-5 rounded-2xl shadow-lg border border-dark-700">
                    <h3 className="font-semibold text-accent">Ongoing Match</h3>
                    <div className="mt-3 text-sm text-gray-300">
                        <div>
                            {state.match.teamA.name} vs {state.match.teamB.name}
                        </div>
                        <div>Overs: {state.match.oversLimit}</div>
                    </div>
                    <div className="mt-4 flex gap-2">
                        <Link
                            to="/live"
                            className="flex-1 text-center py-2 rounded-lg bg-accent text-gray-900 font-semibold hover:bg-emerald-500 transition"
                        >
                            Go to Live
                        </Link>
                        <button
                            onClick={resetMatch}
                            className="flex-1 py-2 rounded-lg bg-danger text-white hover:bg-red-500 transition"
                        >
                            Reset
                        </button>
                    </div>
                </section>
            )}
        </div>
    )
}